import { formatDate } from '@angular/common';
import { Component, Input, OnInit, OnChanges, AfterViewInit, SimpleChanges, OnDestroy } from '@angular/core';
import { SiteEnterococciTrendModel } from 'src/app/models/SiteDetails/SiteEnterococciTrendModel';
import { SiteMonitoringDetails } from 'src/app/models/SiteDetails/SiteMonitoringDetails';
import { uniq } from 'lodash';
import { sub, differenceInCalendarDays, add, parse, parseISO } from 'date-fns';
import { formatTooltipHtml } from '../../shared/google-charts/GoogleChartsTooltipStyles';
import { CHART_DATE_FORMAT, CHART_TOOLTIP_DATE_FORMAT, CHART_TOOLTIP_ENTEROCOCCI_UNITS, DEEP_BLUE_HEX_COLOUR, FORMAT_DATE_LOCALE, TRENDS_TABLE_DATE_FORMAT, TREND_EXPORT_DATA_DATE_FORMAT, TREND_GRAPH_CHART_ANNUAL_DATE_FORMAT } from 'src/app/models/app-constants';
import { Subscription, Observable } from 'rxjs';
import { SitesDetailsService } from 'src/app/services/sitedetails.service';
import { downloadData } from 'src/app/shared/DomUtils';
import { Observe } from 'src/app/shared/custom-decorators/Observe';
import { convertToAESTDateTime, formatDateAEST } from 'src/app/shared/utils';


declare var google : any;

const MEASUREMENT_DATE_FIELD = "MeasurementDt";
const ENTEROCOCCI_FIELD = "EntPer100Ml";

type EnterococciExportDataStruct = { [MEASUREMENT_DATE_FIELD] : Date ; [ENTEROCOCCI_FIELD] : number };

const data = [
    {
        "MeasurementDt": "2023-06-21T00:00:00+00:00",
        "EntPer100Ml": 42
    },
    {
        "MeasurementDt": "2023-06-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2023-06-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-05-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-05-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2023-05-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2023-04-27T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2023-04-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-04-11T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2023-04-04T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2023-03-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-03-23T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2023-03-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-03-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2023-02-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-02-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2023-02-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-01-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-01-25T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "2023-01-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2023-01-13T00:00:00+00:00",
        "EntPer100Ml": 37
    },
    {
        "MeasurementDt": "2023-01-09T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "2023-01-03T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2022-12-28T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2022-12-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-12-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-12-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-12-02T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2022-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-11-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-11-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-11-04T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "2022-10-31T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2022-10-25T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "2022-10-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-10-13T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2022-10-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2022-09-30T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2022-09-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-09-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-09-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2022-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-08-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-08-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-08-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-08-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-07-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-07-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-07-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-07-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2022-07-07T00:00:00+00:00",
        "EntPer100Ml": 22
    },
    {
        "MeasurementDt": "2022-07-01T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2022-06-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-06-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2022-06-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2022-06-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-06-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-05-26T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2022-05-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-05-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-05-03T00:00:00+00:00",
        "EntPer100Ml": 62
    },
    {
        "MeasurementDt": "2022-04-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-04-13T00:00:00+00:00",
        "EntPer100Ml": 150
    },
    {
        "MeasurementDt": "2022-04-07T00:00:00+00:00",
        "EntPer100Ml": 400
    },
    {
        "MeasurementDt": "2022-04-01T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2022-03-28T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2022-03-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-03-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-03-04T00:00:00+00:00",
        "EntPer100Ml": 31
    },
    {
        "MeasurementDt": "2022-02-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-02-21T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2022-02-15T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2022-02-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-02-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-01-28T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2022-01-21T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2022-01-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2022-01-11T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2022-01-05T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-12-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-12-23T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "2021-12-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-12-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-12-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-11-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-11-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-11-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-11-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-11-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-10-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-10-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-10-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-09-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-09-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-09-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-09-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-09-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-08-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-08-25T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-08-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-08-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-08-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-08-02T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-07-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-07-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-07-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-06-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-06-22T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2021-06-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-06-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-06-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-05-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-05-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-05-18T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-05-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-05-06T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2021-04-29T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2021-04-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-04-19T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "2021-04-13T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2021-04-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2021-03-30T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2021-03-23T00:00:00+00:00",
        "EntPer100Ml": 200
    },
    {
        "MeasurementDt": "2021-03-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-03-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-03-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-02-23T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2021-02-17T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2021-02-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-02-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-02-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2021-01-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-01-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2021-01-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-12-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-12-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-12-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2020-11-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-11-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-11-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-11-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-11-02T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2020-10-26T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2020-10-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-10-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-10-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-10-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-09-21T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2020-09-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-08-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-08-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-08-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-08-10T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2020-08-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-07-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-07-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-07-17T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2020-07-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-07-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-06-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-06-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-06-18T00:00:00+00:00",
        "EntPer100Ml": 40
    },
    {
        "MeasurementDt": "2020-06-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2020-06-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-05-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-05-25T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2020-05-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-05-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-05-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2020-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-04-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-03-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-03-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2020-03-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-03-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-02-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-02-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-02-10T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2020-02-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-01-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-01-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-01-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2020-01-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-12-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-12-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-12-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-12-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-11-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-11-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-11-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-10-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-10-18T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2019-10-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-10-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-10-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-09-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-09-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-09-06T00:00:00+00:00",
        "EntPer100Ml": 53
    },
    {
        "MeasurementDt": "2019-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-08-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-08-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-08-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-08-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-07-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-07-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-07-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-07-01T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "2019-06-25T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-06-19T00:00:00+00:00",
        "EntPer100Ml": 86
    },
    {
        "MeasurementDt": "2019-06-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-06-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-06-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-05-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-05-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-05-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-05-09T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "2019-05-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-04-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-04-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-04-16T00:00:00+00:00",
        "EntPer100Ml": 42
    },
    {
        "MeasurementDt": "2019-04-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-04-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-03-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-03-22T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2019-03-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2019-03-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-03-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-02-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-02-21T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2019-02-15T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2019-02-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-02-06T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "2019-01-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-01-24T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "2019-01-17T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2019-01-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2019-01-07T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2019-01-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2018-12-24T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2018-12-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-12-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2018-12-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-11-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-11-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-11-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-10-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-10-25T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2018-10-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-10-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-10-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-09-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-09-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-09-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-09-03T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2018-08-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-08-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-08-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-08-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-07-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-07-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-07-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-07-11T00:00:00+00:00",
        "EntPer100Ml": 110
    },
    {
        "MeasurementDt": "2018-07-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-06-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-06-19T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "2018-06-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-06-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2018-05-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-05-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-05-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-05-15T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2018-05-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-05-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-04-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-04-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-04-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-04-10T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2018-04-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-03-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-03-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-03-14T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2018-03-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-03-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-02-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-02-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2018-02-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-02-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-02-01T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2018-01-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2018-01-19T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2018-01-15T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2018-01-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2018-01-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-12-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-12-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-12-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-12-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-12-04T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2017-11-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-11-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-11-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-11-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-11-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-10-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-10-23T00:00:00+00:00",
        "EntPer100Ml": 56
    },
    {
        "MeasurementDt": "2017-10-17T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2017-10-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-10-05T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2017-09-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-09-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-09-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-09-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-08-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-08-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-08-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-07-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-07-24T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2017-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-07-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-06-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-06-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-06-20T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2017-06-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-06-08T00:00:00+00:00",
        "EntPer100Ml": 41
    },
    {
        "MeasurementDt": "2017-06-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-05-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-05-22T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-05-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-04-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-04-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-04-07T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2017-04-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2017-03-28T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2017-03-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2017-03-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-03-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-02-27T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2017-02-21T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "2017-02-15T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2017-02-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-02-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-01-30T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2017-01-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-01-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2017-01-11T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2017-01-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-12-29T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2016-12-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-12-16T00:00:00+00:00",
        "EntPer100Ml": 27
    },
    {
        "MeasurementDt": "2016-12-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-12-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-11-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-11-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-11-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-10-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-10-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-09-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-09-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-09-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-09-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-09-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-08-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-08-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-08-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-08-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-07-27T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-07-21T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2016-07-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-07-08T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2016-07-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-06-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-06-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-06-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-06-09T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2016-06-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-05-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-05-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-05-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-05-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-04-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-04-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-04-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-04-04T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2016-03-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-03-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-03-16T00:00:00+00:00",
        "EntPer100Ml": 30
    },
    {
        "MeasurementDt": "2016-03-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-03-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-02-27T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-02-21T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2016-02-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-02-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2016-02-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-01-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2016-01-22T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2016-01-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2016-01-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-12-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-12-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2015-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-12-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-12-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-11-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-11-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2015-11-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-11-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-11-05T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2015-10-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-10-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-10-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-09-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-09-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2015-09-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-09-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-09-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-08-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-08-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-08-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-08-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-08-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-07-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-06-26T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-06-20T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2015-06-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-06-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-06-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-05-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-05-22T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2015-05-17T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2015-05-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-05-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-04-27T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2015-04-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-04-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-04-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2015-03-25T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2015-03-17T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2015-03-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-03-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-02-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-02-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-02-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-02-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-01-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-01-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-01-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2015-01-05T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2014-12-28T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2014-12-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-12-13T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2014-12-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-11-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-11-18T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2014-11-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-11-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-10-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-10-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-10-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-09-30T00:00:00+00:00",
        "EntPer100Ml": 25
    },
    {
        "MeasurementDt": "2014-09-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-09-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-09-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-08-27T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2014-08-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-08-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-08-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-08-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-08-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-07-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-07-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-07-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-06-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-06-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2014-06-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2014-06-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-05-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-05-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-05-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-05-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-04-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-04-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-04-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-04-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2014-03-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-03-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-03-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-03-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-02-25T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2014-02-17T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2014-02-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-02-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-01-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2014-01-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2014-01-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-12-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-12-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-12-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-12-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-11-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-11-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-11-05T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "2013-10-28T00:00:00+00:00",
        "EntPer100Ml": 190
    },
    {
        "MeasurementDt": "2013-10-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-10-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-10-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-09-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-09-22T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-09-16T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2013-09-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-09-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-08-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-08-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-08-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-08-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-08-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-07-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-07-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-07-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-07-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-06-30T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "2013-06-24T00:00:00+00:00",
        "EntPer100Ml": 25
    },
    {
        "MeasurementDt": "2013-06-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-06-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-06-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-05-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-05-25T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-05-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-05-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-05-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-05-01T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2013-04-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-04-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-04-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-04-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2013-04-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-03-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-03-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-03-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-03-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-03-01T00:00:00+00:00",
        "EntPer100Ml": 140
    },
    {
        "MeasurementDt": "2013-02-23T00:00:00+00:00",
        "EntPer100Ml": 52
    },
    {
        "MeasurementDt": "2013-02-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-02-11T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2013-02-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-01-30T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2013-01-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-01-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2013-01-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-01-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2013-01-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-12-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-12-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-12-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-11-25T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2012-11-19T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "2012-11-13T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2012-11-07T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2012-11-01T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2012-10-26T00:00:00+00:00",
        "EntPer100Ml": 30
    },
    {
        "MeasurementDt": "2012-10-18T00:00:00+00:00",
        "EntPer100Ml": 32
    },
    {
        "MeasurementDt": "2012-10-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-09-27T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "2012-09-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-09-13T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "2012-09-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-08-26T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2012-08-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-08-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-08-08T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2012-08-02T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "2012-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-07-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-07-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-07-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-07-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-06-27T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "2012-06-21T00:00:00+00:00",
        "EntPer100Ml": 36
    },
    {
        "MeasurementDt": "2012-06-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-06-08T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2012-06-04T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "2012-05-29T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2012-05-23T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2012-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-05-11T00:00:00+00:00",
        "EntPer100Ml": 81
    },
    {
        "MeasurementDt": "2012-05-04T00:00:00+00:00",
        "EntPer100Ml": 22
    },
    {
        "MeasurementDt": "2012-04-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-04-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-04-17T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2012-04-11T00:00:00+00:00",
        "EntPer100Ml": 46
    },
    {
        "MeasurementDt": "2012-04-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-03-30T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2012-03-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-03-18T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2012-03-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-03-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2012-02-29T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2012-02-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2012-02-17T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2012-02-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-02-05T00:00:00+00:00",
        "EntPer100Ml": 30
    },
    {
        "MeasurementDt": "2012-01-30T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2012-01-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2012-01-18T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2012-01-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2012-01-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-12-30T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2011-12-23T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2011-12-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-12-13T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2011-12-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-12-01T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-11-25T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2011-11-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-11-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-11-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-11-01T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2011-10-26T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2011-10-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-10-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-10-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-09-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-09-26T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2011-09-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-09-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2011-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-08-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-08-21T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2011-08-15T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2011-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-08-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-07-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-07-21T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2011-07-16T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-07-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-07-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-06-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-06-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-06-16T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2011-06-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-06-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2011-05-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-05-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-05-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-05-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-05-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-04-29T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-04-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-04-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-04-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-04-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-03-30T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2011-03-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-03-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-03-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-03-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-02-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2011-02-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-02-16T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2011-02-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2011-02-04T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2011-01-29T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "2011-01-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-01-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-01-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2011-01-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-12-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-12-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2010-12-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-12-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-12-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2010-11-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2010-11-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2010-11-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-11-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-11-06T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2010-10-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-10-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-10-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-10-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-10-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-09-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-09-13T00:00:00+00:00",
        "EntPer100Ml": 23
    },
    {
        "MeasurementDt": "2010-09-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-08-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-08-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-08-14T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2010-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-08-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-07-21T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "2010-07-15T00:00:00+00:00",
        "EntPer100Ml": 240
    },
    {
        "MeasurementDt": "2010-07-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-07-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-06-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-06-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-06-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-06-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-06-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-05-28T00:00:00+00:00",
        "EntPer100Ml": 47
    },
    {
        "MeasurementDt": "2010-05-22T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "2010-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-05-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-04-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-04-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-04-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-04-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-03-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2010-03-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-03-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-03-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2010-03-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-02-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2010-02-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2010-02-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2010-02-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-02-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2010-01-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-01-22T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "2010-01-16T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2010-01-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2010-01-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2009-12-29T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2009-12-21T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2009-12-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2009-12-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-12-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-11-25T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2009-11-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2009-11-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-11-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-11-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-10-26T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "2009-10-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-10-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-10-08T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2009-10-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-09-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-09-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-09-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-08-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-08-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-08-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-08-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-08-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-07-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-07-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-07-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "2009-07-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-07-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-06-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-06-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-06-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-06-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-06-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-05-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-05-23T00:00:00+00:00",
        "EntPer100Ml": 32
    },
    {
        "MeasurementDt": "2009-05-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-05-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-05-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-04-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-04-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-04-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-04-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-04-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-03-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-03-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-03-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-03-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2009-03-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2009-02-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-02-22T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2009-02-16T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2009-02-10T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2009-02-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-01-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-01-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-01-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2009-01-11T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2009-01-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-12-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-12-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-12-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-12-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-12-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-11-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-11-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-11-18T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-11-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-11-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-10-30T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2008-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-10-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-10-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-10-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-10-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-09-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-09-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-09-07T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2008-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-08-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-08-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-08-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-08-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-08-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-07-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-07-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-07-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-07-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-06-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-06-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-06-15T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-06-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-06-03T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-05-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-05-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-05-04T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-04-21T00:00:00+00:00",
        "EntPer100Ml": 44
    },
    {
        "MeasurementDt": "2008-04-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-04-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-04-03T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-03-27T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2008-03-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-03-16T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2008-03-10T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2008-03-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-02-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-02-21T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2008-02-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2008-02-09T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-02-04T00:00:00+00:00",
        "EntPer100Ml": 180
    },
    {
        "MeasurementDt": "2008-01-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2008-01-22T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2008-01-16T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2008-01-09T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2008-01-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-12-28T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-12-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-12-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-12-05T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2007-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-11-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-11-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-11-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-10-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-10-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-10-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-09-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-09-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-09-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-09-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-09-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-08-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-08-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-08-19T00:00:00+00:00",
        "EntPer100Ml": 46
    },
    {
        "MeasurementDt": "2007-08-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-08-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-07-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-07-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-07-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-07-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-07-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-06-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-06-20T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2007-06-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-06-08T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2007-06-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-05-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-05-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-05-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-05-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-05-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-04-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-04-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-04-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-04-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-03-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-03-22T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2007-03-16T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-03-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-03-04T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2007-02-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-02-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2007-02-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-02-08T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2007-02-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-01-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-01-21T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2007-01-15T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2007-01-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2007-01-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-12-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-12-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-12-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-12-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-12-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-11-28T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-11-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-11-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-11-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-11-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-10-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-10-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-10-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-10-11T00:00:00+00:00",
        "EntPer100Ml": 64
    },
    {
        "MeasurementDt": "2006-10-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-09-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-09-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-09-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-09-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-09-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-08-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-08-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-08-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-08-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-08-06T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2006-07-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-07-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-07-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-07-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-07-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-07-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-06-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-06-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-06-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-06-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-06-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-05-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-05-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-05-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-05-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-05-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-04-26T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2006-04-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-04-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-04-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-04-02T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-03-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-03-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-03-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-03-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-03-03T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2006-02-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-02-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-02-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-02-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2006-02-01T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2006-01-25T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2006-01-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-01-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-01-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2006-01-03T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2005-12-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-12-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-12-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-12-09T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2005-12-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-11-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-11-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-11-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-11-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-11-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-10-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-10-22T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2005-10-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-10-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-10-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-09-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-09-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-09-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-09-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-09-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-08-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-08-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-08-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-08-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-08-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-07-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-07-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-07-12T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2005-07-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-06-30T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2005-06-24T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2005-06-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-06-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-06-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-05-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-05-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-05-19T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2005-05-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-05-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-05-01T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-04-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-04-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-04-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-04-07T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2005-04-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-03-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-03-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-03-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-03-08T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-03-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-02-24T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2005-02-18T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2005-02-12T00:00:00+00:00",
        "EntPer100Ml": 300
    },
    {
        "MeasurementDt": "2005-02-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2005-01-31T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2005-01-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-01-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-01-13T00:00:00+00:00",
        "EntPer100Ml": 50
    },
    {
        "MeasurementDt": "2005-01-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2005-01-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-12-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-12-28T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-12-20T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-12-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-12-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-12-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-11-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-11-20T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2004-11-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-11-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-11-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-10-27T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-10-21T00:00:00+00:00",
        "EntPer100Ml": 70
    },
    {
        "MeasurementDt": "2004-10-15T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2004-10-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-10-03T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2004-09-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-09-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-09-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-09-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-09-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-08-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-08-16T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-08-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-08-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-07-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-07-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-07-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-07-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-07-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-06-29T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-06-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-06-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-06-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-06-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-05-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-05-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-05-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-05-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-05-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-04-30T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2004-04-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-04-18T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2004-04-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-04-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-03-31T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-03-25T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-03-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-03-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-03-07T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2004-03-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-02-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-02-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-02-12T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-02-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-01-31T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2004-01-25T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2004-01-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-01-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2004-01-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-12-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-12-27T00:00:00+00:00",
        "EntPer100Ml": 52
    },
    {
        "MeasurementDt": "2003-12-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-12-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-12-08T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2003-12-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-11-26T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2003-11-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-11-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-11-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-11-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-10-27T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2003-10-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-10-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-10-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-09-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-09-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-09-15T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2003-09-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-09-03T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2003-08-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-08-16T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2003-08-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-08-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-07-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-07-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-07-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-07-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-07-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-06-29T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-06-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-06-17T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2003-06-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-06-05T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-05-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-05-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-05-18T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2003-05-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-05-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-04-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-04-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-04-18T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2003-04-12T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2003-04-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-04-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-03-25T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2003-03-19T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2003-03-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-03-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-03-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-02-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-02-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-02-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-02-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-01-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-01-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-01-18T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2003-01-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2003-01-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-12-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-12-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-12-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-12-13T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2002-12-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-12-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-11-25T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2002-11-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-11-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-11-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-11-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-10-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-10-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-10-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-10-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-10-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-09-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-09-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-09-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-09-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-09-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-08-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-08-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-08-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-08-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-07-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-07-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-07-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-07-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-07-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-06-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-06-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-06-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-06-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-06-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-05-29T00:00:00+00:00",
        "EntPer100Ml": 28
    },
    {
        "MeasurementDt": "2002-05-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-05-17T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2002-05-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-05-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-04-29T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "2002-04-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-04-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-04-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-04-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-03-30T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2002-03-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-03-18T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-03-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2002-03-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-02-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-02-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-02-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-02-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-02-04T00:00:00+00:00",
        "EntPer100Ml": 90
    },
    {
        "MeasurementDt": "2002-01-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-01-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2002-01-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-01-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2002-01-05T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2001-12-30T00:00:00+00:00",
        "EntPer100Ml": 42
    },
    {
        "MeasurementDt": "2001-12-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-12-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-12-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-12-06T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2001-11-30T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2001-11-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-11-18T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-11-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-11-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-10-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-10-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-10-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-10-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-10-01T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-09-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-09-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-09-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-09-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-09-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-08-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-08-20T00:00:00+00:00",
        "EntPer100Ml": 40
    },
    {
        "MeasurementDt": "2001-08-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-08-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-08-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-07-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-07-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-07-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-07-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-07-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-06-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-06-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-06-15T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2001-06-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-06-03T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2001-05-28T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-05-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-05-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-05-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-04-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-04-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-04-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-04-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-04-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-03-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-03-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2001-03-17T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2001-03-11T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2001-03-05T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "2001-02-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-02-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-02-15T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2001-02-09T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2001-02-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-01-29T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2001-01-22T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2001-01-16T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2001-01-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2001-01-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-12-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-12-23T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2000-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-12-11T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "2000-12-05T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "2000-11-29T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2000-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-11-17T00:00:00+00:00",
        "EntPer100Ml": 48
    },
    {
        "MeasurementDt": "2000-11-11T00:00:00+00:00",
        "EntPer100Ml": 2300
    },
    {
        "MeasurementDt": "2000-11-05T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2000-10-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-10-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-10-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-09-30T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "2000-09-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-09-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-09-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-09-06T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-08-31T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-08-25T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-08-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-08-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-08-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-08-01T00:00:00+00:00",
        "EntPer100Ml": 34
    },
    {
        "MeasurementDt": "2000-07-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-07-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-07-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-07-02T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "2000-06-26T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2000-06-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-06-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-06-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-06-02T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-05-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-05-21T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "2000-05-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-05-09T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2000-05-03T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2000-04-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-04-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-04-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-04-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-04-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-03-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-03-22T00:00:00+00:00",
        "EntPer100Ml": 120
    },
    {
        "MeasurementDt": "2000-03-16T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "2000-03-10T00:00:00+00:00",
        "EntPer100Ml": 60
    },
    {
        "MeasurementDt": "2000-03-04T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-02-27T00:00:00+00:00",
        "EntPer100Ml": 44
    },
    {
        "MeasurementDt": "2000-02-21T00:00:00+00:00",
        "EntPer100Ml": 44
    },
    {
        "MeasurementDt": "2000-02-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-02-09T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "2000-02-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-01-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "2000-01-22T00:00:00+00:00",
        "EntPer100Ml": 24
    },
    {
        "MeasurementDt": "2000-01-16T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "2000-01-11T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "2000-01-04T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-12-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-12-23T00:00:00+00:00",
        "EntPer100Ml": 22
    },
    {
        "MeasurementDt": "1999-12-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-12-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-12-05T00:00:00+00:00",
        "EntPer100Ml": 22
    },
    {
        "MeasurementDt": "1999-11-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-11-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-11-17T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1999-11-11T00:00:00+00:00",
        "EntPer100Ml": 180
    },
    {
        "MeasurementDt": "1999-11-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-10-29T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-10-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-10-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-10-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-09-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-09-23T00:00:00+00:00",
        "EntPer100Ml": 80
    },
    {
        "MeasurementDt": "1999-09-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-09-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-09-06T00:00:00+00:00",
        "EntPer100Ml": 88
    },
    {
        "MeasurementDt": "1999-08-31T00:00:00+00:00",
        "EntPer100Ml": 50
    },
    {
        "MeasurementDt": "1999-08-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-08-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-08-13T00:00:00+00:00",
        "EntPer100Ml": 44
    },
    {
        "MeasurementDt": "1999-08-06T00:00:00+00:00",
        "EntPer100Ml": 30
    },
    {
        "MeasurementDt": "1999-08-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-07-26T00:00:00+00:00",
        "EntPer100Ml": 66
    },
    {
        "MeasurementDt": "1999-07-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-07-14T00:00:00+00:00",
        "EntPer100Ml": 88
    },
    {
        "MeasurementDt": "1999-07-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-07-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-06-25T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-06-21T00:00:00+00:00",
        "EntPer100Ml": 196
    },
    {
        "MeasurementDt": "1999-06-15T00:00:00+00:00",
        "EntPer100Ml": 94
    },
    {
        "MeasurementDt": "1999-06-08T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-06-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-05-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-05-20T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-05-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-05-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-05-03T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-04-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1999-04-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-04-15T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "1999-04-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-04-02T00:00:00+00:00",
        "EntPer100Ml": 30
    },
    {
        "MeasurementDt": "1999-03-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-03-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-03-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-03-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-03-04T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-02-25T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "1999-02-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-02-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-02-08T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1999-02-02T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1999-01-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-01-21T00:00:00+00:00",
        "EntPer100Ml": 34
    },
    {
        "MeasurementDt": "1999-01-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1999-01-09T00:00:00+00:00",
        "EntPer100Ml": 50
    },
    {
        "MeasurementDt": "1999-01-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-12-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-12-22T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1998-12-16T00:00:00+00:00",
        "EntPer100Ml": 40
    },
    {
        "MeasurementDt": "1998-12-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-12-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-11-28T00:00:00+00:00",
        "EntPer100Ml": 70
    },
    {
        "MeasurementDt": "1998-11-22T00:00:00+00:00",
        "EntPer100Ml": 210
    },
    {
        "MeasurementDt": "1998-11-16T00:00:00+00:00",
        "EntPer100Ml": 24
    },
    {
        "MeasurementDt": "1998-11-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-11-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-10-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-10-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-10-17T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1998-10-11T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-10-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-09-30T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1998-09-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-09-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-09-11T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "1998-09-04T00:00:00+00:00",
        "EntPer100Ml": 68
    },
    {
        "MeasurementDt": "1998-08-31T00:00:00+00:00",
        "EntPer100Ml": 26
    },
    {
        "MeasurementDt": "1998-08-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-08-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-08-12T00:00:00+00:00",
        "EntPer100Ml": 50
    },
    {
        "MeasurementDt": "1998-08-06T00:00:00+00:00",
        "EntPer100Ml": 200
    },
    {
        "MeasurementDt": "1998-07-31T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-07-24T00:00:00+00:00",
        "EntPer100Ml": 26
    },
    {
        "MeasurementDt": "1998-07-20T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1998-07-13T00:00:00+00:00",
        "EntPer100Ml": 36
    },
    {
        "MeasurementDt": "1998-07-07T00:00:00+00:00",
        "EntPer100Ml": 32
    },
    {
        "MeasurementDt": "1998-07-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-06-25T00:00:00+00:00",
        "EntPer100Ml": 800
    },
    {
        "MeasurementDt": "1998-06-19T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1998-06-15T00:00:00+00:00",
        "EntPer100Ml": 36
    },
    {
        "MeasurementDt": "1998-06-09T00:00:00+00:00",
        "EntPer100Ml": 28
    },
    {
        "MeasurementDt": "1998-06-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-05-26T00:00:00+00:00",
        "EntPer100Ml": 56
    },
    {
        "MeasurementDt": "1998-05-20T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1998-05-14T00:00:00+00:00",
        "EntPer100Ml": 1900
    },
    {
        "MeasurementDt": "1998-05-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-05-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-04-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-04-20T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1998-04-14T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1998-04-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-04-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-03-27T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1998-03-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-03-15T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1998-03-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-03-03T00:00:00+00:00",
        "EntPer100Ml": 32
    },
    {
        "MeasurementDt": "1998-02-25T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1998-02-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-02-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-02-07T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1998-02-01T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1998-01-26T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1998-01-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-01-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-01-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1998-01-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-12-27T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1997-12-21T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-12-15T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1997-12-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-12-03T00:00:00+00:00",
        "EntPer100Ml": 130
    },
    {
        "MeasurementDt": "1997-11-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-11-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-11-15T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1997-11-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-11-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-10-28T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1997-10-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-10-16T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-10-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-10-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-09-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-09-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-09-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-09-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-09-04T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-08-29T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-08-22T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "1997-08-18T00:00:00+00:00",
        "EntPer100Ml": 36
    },
    {
        "MeasurementDt": "1997-08-11T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1997-08-05T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1997-07-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-07-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-07-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-07-11T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1997-07-07T00:00:00+00:00",
        "EntPer100Ml": 52
    },
    {
        "MeasurementDt": "1997-06-30T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1997-06-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-06-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-06-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-06-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-05-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-05-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-05-19T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1997-05-13T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1997-05-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-05-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-04-25T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1997-04-19T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1997-04-13T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-04-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-04-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-03-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-03-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-03-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-03-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-03-02T00:00:00+00:00",
        "EntPer100Ml": 28
    },
    {
        "MeasurementDt": "1997-02-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-02-18T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1997-02-12T00:00:00+00:00",
        "EntPer100Ml": 130
    },
    {
        "MeasurementDt": "1997-02-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-01-31T00:00:00+00:00",
        "EntPer100Ml": 38
    },
    {
        "MeasurementDt": "1997-01-25T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1997-01-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1997-01-14T00:00:00+00:00",
        "EntPer100Ml": 32
    },
    {
        "MeasurementDt": "1997-01-07T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1997-01-01T00:00:00+00:00",
        "EntPer100Ml": 98
    },
    {
        "MeasurementDt": "1996-12-26T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-12-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-12-14T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "1996-12-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-12-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-11-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1996-11-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-11-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1996-11-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-11-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-10-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-10-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-10-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-10-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-10-03T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1996-09-27T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1996-09-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-09-16T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-09-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-09-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-08-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-08-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-08-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-08-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-07-29T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1996-07-23T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1996-07-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-07-11T00:00:00+00:00",
        "EntPer100Ml": 28
    },
    {
        "MeasurementDt": "1996-07-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-06-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-06-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-06-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-06-12T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1996-06-05T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-05-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-05-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-05-17T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-05-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-05-07T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1996-04-30T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-04-24T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1996-04-18T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1996-04-12T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-04-06T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1996-03-31T00:00:00+00:00",
        "EntPer100Ml": 160
    },
    {
        "MeasurementDt": "1996-03-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-03-21T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "1996-03-13T00:00:00+00:00",
        "EntPer100Ml": 46
    },
    {
        "MeasurementDt": "1996-03-07T00:00:00+00:00",
        "EntPer100Ml": 62
    },
    {
        "MeasurementDt": "1996-03-01T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-02-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1996-02-18T00:00:00+00:00",
        "EntPer100Ml": 60
    },
    {
        "MeasurementDt": "1996-02-12T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1996-02-06T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "1996-01-31T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1996-01-25T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-01-19T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1996-01-13T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1996-01-07T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1996-01-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-12-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-12-20T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-12-14T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1995-12-08T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1995-12-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-11-26T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-11-20T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "1995-11-14T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-11-08T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-11-02T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-10-27T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-10-21T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-10-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-10-09T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1995-10-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-09-27T00:00:00+00:00",
        "EntPer100Ml": 45
    },
    {
        "MeasurementDt": "1995-09-21T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1995-09-15T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-09-09T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-09-03T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-08-28T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-08-22T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-08-16T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-08-10T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-08-04T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1995-07-29T00:00:00+00:00",
        "EntPer100Ml": 22
    },
    {
        "MeasurementDt": "1995-07-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1995-07-18T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1995-07-11T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1995-07-05T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1995-06-29T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-06-23T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1995-06-17T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "1995-06-11T00:00:00+00:00",
        "EntPer100Ml": 25
    },
    {
        "MeasurementDt": "1995-06-05T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1995-05-30T00:00:00+00:00",
        "EntPer100Ml": 25
    },
    {
        "MeasurementDt": "1995-05-24T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-05-18T00:00:00+00:00",
        "EntPer100Ml": 78
    },
    {
        "MeasurementDt": "1995-05-12T00:00:00+00:00",
        "EntPer100Ml": 23
    },
    {
        "MeasurementDt": "1995-05-06T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1995-04-30T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1995-04-24T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1995-04-18T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-04-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1995-04-06T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1995-03-31T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1995-03-25T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-03-19T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-03-13T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "1995-03-07T00:00:00+00:00",
        "EntPer100Ml": 27
    },
    {
        "MeasurementDt": "1995-03-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1995-02-23T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-02-17T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1995-02-11T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "1995-02-05T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1995-01-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1995-01-24T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1995-01-18T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1995-01-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1995-01-06T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1994-12-31T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-12-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-12-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-12-13T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "1994-12-07T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-12-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1994-11-25T00:00:00+00:00",
        "EntPer100Ml": 45
    },
    {
        "MeasurementDt": "1994-11-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-11-13T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-11-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-11-01T00:00:00+00:00",
        "EntPer100Ml": 0
    },
    {
        "MeasurementDt": "1994-10-26T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-10-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-10-14T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-10-08T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-10-02T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "1994-09-26T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-09-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-09-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-09-08T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-09-02T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-08-27T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-08-21T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-08-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-08-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-08-15T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-08-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-08-02T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-07-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-07-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-07-25T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "1994-07-24T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-07-22T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-07-16T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1994-07-11T00:00:00+00:00",
        "EntPer100Ml": 42
    },
    {
        "MeasurementDt": "1994-07-10T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-07-09T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1994-07-04T00:00:00+00:00",
        "EntPer100Ml": 24
    },
    {
        "MeasurementDt": "1994-07-03T00:00:00+00:00",
        "EntPer100Ml": 24
    },
    {
        "MeasurementDt": "1994-07-02T00:00:00+00:00",
        "EntPer100Ml": 41
    },
    {
        "MeasurementDt": "1994-07-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-06-30T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-06-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-06-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-06-22T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "1994-06-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-06-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-06-09T00:00:00+00:00",
        "EntPer100Ml": 27
    },
    {
        "MeasurementDt": "1994-06-08T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1994-06-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-05-29T00:00:00+00:00",
        "EntPer100Ml": 560
    },
    {
        "MeasurementDt": "1994-05-23T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-05-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-05-17T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-05-14T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "1994-05-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-05-11T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-05-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-05-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-05-06T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "1994-05-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-05-04T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "1994-05-03T00:00:00+00:00",
        "EntPer100Ml": 99
    },
    {
        "MeasurementDt": "1994-05-02T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-04-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-04-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1994-04-17T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "1994-04-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-04-15T00:00:00+00:00",
        "EntPer100Ml": 35
    },
    {
        "MeasurementDt": "1994-04-14T00:00:00+00:00",
        "EntPer100Ml": 27
    },
    {
        "MeasurementDt": "1994-04-13T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-04-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-04-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-04-05T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-04-02T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-04-01T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "1994-03-31T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-30T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-03-29T00:00:00+00:00",
        "EntPer100Ml": 14
    },
    {
        "MeasurementDt": "1994-03-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-24T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1994-03-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-03-13T00:00:00+00:00",
        "EntPer100Ml": 59
    },
    {
        "MeasurementDt": "1994-03-12T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-09T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-03-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-07T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-03-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-03-02T00:00:00+00:00",
        "EntPer100Ml": 34
    },
    {
        "MeasurementDt": "1994-03-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-02-28T00:00:00+00:00",
        "EntPer100Ml": 19
    },
    {
        "MeasurementDt": "1994-02-22T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-02-21T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-02-20T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-02-19T00:00:00+00:00",
        "EntPer100Ml": 35
    },
    {
        "MeasurementDt": "1994-02-18T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1994-02-17T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-02-16T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-02-15T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-02-14T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-02-13T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-02-10T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-02-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-01-29T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1994-01-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1994-01-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1994-01-19T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1994-01-18T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1994-01-17T00:00:00+00:00",
        "EntPer100Ml": 93
    },
    {
        "MeasurementDt": "1994-01-16T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1994-01-11T00:00:00+00:00",
        "EntPer100Ml": 5
    },
    {
        "MeasurementDt": "1994-01-05T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-12-30T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1993-12-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-12-18T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1993-12-14T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1993-12-12T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1993-12-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-12-09T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "1993-12-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-12-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-12-04T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "1993-11-30T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-11-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-11-22T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-21T00:00:00+00:00",
        "EntPer100Ml": 8
    },
    {
        "MeasurementDt": "1993-11-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-11-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-11-18T00:00:00+00:00",
        "EntPer100Ml": 13
    },
    {
        "MeasurementDt": "1993-11-16T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-11-15T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-14T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "1993-11-12T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-11-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-11-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-31T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-10-25T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-10-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-17T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1993-10-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-02T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-10-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-09-25T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1993-09-19T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-09-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-09-15T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-09-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-09-13T00:00:00+00:00",
        "EntPer100Ml": 28
    },
    {
        "MeasurementDt": "1993-09-12T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-09-11T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-09-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-09-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-09-01T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-08-31T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-30T00:00:00+00:00",
        "EntPer100Ml": 26
    },
    {
        "MeasurementDt": "1993-08-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-26T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-14T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-08-06T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-08-05T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-08-04T00:00:00+00:00",
        "EntPer100Ml": 18
    },
    {
        "MeasurementDt": "1993-08-02T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-08-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-31T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "1993-07-30T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-27T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-22T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1993-07-21T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "1993-07-20T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-07-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-18T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-07-15T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-14T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1993-07-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-12T00:00:00+00:00",
        "EntPer100Ml": 24
    },
    {
        "MeasurementDt": "1993-07-11T00:00:00+00:00",
        "EntPer100Ml": 10
    },
    {
        "MeasurementDt": "1993-07-10T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-07-09T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "1993-07-08T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-07-07T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-07-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-27T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-21T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-15T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-09T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "1993-06-08T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-07T00:00:00+00:00",
        "EntPer100Ml": 36
    },
    {
        "MeasurementDt": "1993-06-06T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-06-02T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-25T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-24T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-05-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-22T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-17T00:00:00+00:00",
        "EntPer100Ml": 42
    },
    {
        "MeasurementDt": "1993-05-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-05-01T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-30T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-29T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-04-19T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-04-18T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-17T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-16T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-04-10T00:00:00+00:00",
        "EntPer100Ml": 38
    },
    {
        "MeasurementDt": "1993-04-08T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1993-04-07T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1993-04-06T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-04-05T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-04T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-04-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-29T00:00:00+00:00",
        "EntPer100Ml": 16
    },
    {
        "MeasurementDt": "1993-03-28T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-27T00:00:00+00:00",
        "EntPer100Ml": 12
    },
    {
        "MeasurementDt": "1993-03-26T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-03-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-23T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-22T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-03-17T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-16T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1993-03-15T00:00:00+00:00",
        "EntPer100Ml": 9
    },
    {
        "MeasurementDt": "1993-03-14T00:00:00+00:00",
        "EntPer100Ml": 20
    },
    {
        "MeasurementDt": "1993-03-13T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-11T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-10T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-03-09T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-03-08T00:00:00+00:00",
        "EntPer100Ml": 15
    },
    {
        "MeasurementDt": "1993-03-05T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1993-02-27T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-02-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-02-23T00:00:00+00:00",
        "EntPer100Ml": 4
    },
    {
        "MeasurementDt": "1993-02-22T00:00:00+00:00",
        "EntPer100Ml": 17
    },
    {
        "MeasurementDt": "1993-02-21T00:00:00+00:00",
        "EntPer100Ml": 6
    },
    {
        "MeasurementDt": "1993-02-20T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-02-19T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-02-18T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-02-15T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-02-12T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1993-02-11T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-02-10T00:00:00+00:00",
        "EntPer100Ml": 11
    },
    {
        "MeasurementDt": "1993-02-09T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-02-08T00:00:00+00:00",
        "EntPer100Ml": 3
    },
    {
        "MeasurementDt": "1993-02-07T00:00:00+00:00",
        "EntPer100Ml": 21
    },
    {
        "MeasurementDt": "1993-02-06T00:00:00+00:00",
        "EntPer100Ml": 19
    },
    {
        "MeasurementDt": "1993-02-03T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-01-26T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-01-25T00:00:00+00:00",
        "EntPer100Ml": 45
    },
    {
        "MeasurementDt": "1993-01-24T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-01-23T00:00:00+00:00",
        "EntPer100Ml": 7
    },
    {
        "MeasurementDt": "1993-01-22T00:00:00+00:00",
        "EntPer100Ml": 2
    },
    {
        "MeasurementDt": "1993-01-16T00:00:00+00:00",
        "EntPer100Ml": 1
    },
    {
        "MeasurementDt": "1993-01-10T00:00:00+00:00",
        "EntPer100Ml": 40
    },
    {
        "MeasurementDt": "1993-01-04T00:00:00+00:00",
        "EntPer100Ml": 1
    }
];


@Component({
	selector: 'app-site-trends',
	templateUrl: './site-trends.component.html',
	styleUrls: ['./site-trends.component.scss']
})

export class SiteTrendsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
	@Input() enterococciTrends : SiteEnterococciTrendModel[];
	@Input() siteName : string;
	@Input() siteId : string = "";
	@Observe("enterococciTrends") private enterococciTrends$!: Observable<SiteEnterococciTrendModel[]>;
	@Input() monitoringDetails : SiteMonitoringDetails[];
	activeTabIndex : number = 0;

	annualChartData : any;
	annualChartOptions : any;
	annualTrendsData : any; 
		
	monthlyChartData : any;
	monthlyChartOptions : any;
	monthlyTrendsData : any;

	monitoringDetailsText : string;
	private exportSub : Subscription;
	private dataSub : Subscription;

	private ENTEROCOCCI_COLUMN = "Enterococci";
	private ENTEROCOCCI_LABEL = `${this.ENTEROCOCCI_COLUMN} (${CHART_TOOLTIP_ENTEROCOCCI_UNITS})`;
	private MEASUREMENT_DATE_LABEL = "Measurement Date";	
	

	constructor(private siteDetailsService : SitesDetailsService)
	{

	}

	ngOnInit() : void 
	{
		this.dataSub = this.enterococciTrends$?.subscribe({
			next : (value) => {
				if(Array.isArray(value))
				{
					google?.charts?.load('current', {packages: ['corechart', 'scatter', 'line']});					
					google?.charts?.setOnLoadCallback(this.createChart);
				}				
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}

		});
	}

	ngOnChanges(changes : SimpleChanges) : void 
	{
		if (this.monitoringDetailsText == null && this.monitoringDetails && this.monitoringDetails.length > 0)
		{
			this.monitoringDetailsText = this.monitoringDetails[0].MonitoringPeriod;
		}		
	}

	ngAfterViewInit(): void 
	{
		
	}	

	ngOnDestroy(): void {
		this.exportSub && this.exportSub?.unsubscribe();
		this.dataSub && this.dataSub?.unsubscribe();
	}

	private createChart = () => {		
		if(!google?.visualization?.DataTable || !google?.visualization?.DataView)
		{
			return;
		}

		//const sortedArray = data?.map((a) => ({...a, MeasurementDt : new Date(Date.parse(a.MeasurementDt))})).sort(function compare(a, b) {
		const sortedArray = this.enterococciTrends?.sort(function compare(a, b) {		
			const dateA = new Date(a.MeasurementDt);
			const dateB = new Date(b.MeasurementDt);
			return dateB.getTime() - dateA.getTime();
		});
		let maxDate = new Date();
		let minDate = sub(maxDate, {days : 31});		
		const monthlyData = sortedArray.filter((d) => {			
			return d.MeasurementDt.getTime() >= minDate.getTime() &&
				d.MeasurementDt.getTime() <= maxDate.getTime();
		});
		
		const chartData = new google.visualization.DataTable();
		chartData.addColumn('date', this.MEASUREMENT_DATE_LABEL);
		chartData.addColumn('number', this.ENTEROCOCCI_COLUMN);
		chartData.addColumn({'role' : 'style'});
		chartData.addColumn({'type' : 'string', 'role' : 'tooltip', 'p': {'html': true}});	

		this.monthlyTrendsData = [[this.MEASUREMENT_DATE_LABEL], [this.ENTEROCOCCI_LABEL]];
		let diffCalendarDays = differenceInCalendarDays(maxDate, minDate);
		for(let i = 0; i <= diffCalendarDays ; ++i)
		{			
			const day = sub(maxDate, {days : i });				
			const dayData = monthlyData.find((a : any) => {
				const measurementDt = convertToAESTDateTime(a.MeasurementDt) ?? a.MeasurementDt;					
				const diff = differenceInCalendarDays(day, measurementDt);				
				return 0 === diff;
			});
			if(dayData)
			{
				const measurementDt = convertToAESTDateTime(dayData.MeasurementDt) ?? dayData.MeasurementDt;
				const dt = new Date(measurementDt.getFullYear(), measurementDt.getMonth(), measurementDt.getDate(),
					measurementDt.getHours(), measurementDt.getMinutes(), measurementDt.getSeconds(), measurementDt.getMilliseconds());

				chartData.addRow([dt, dayData.EntPer100Ml, 'color: red',
					formatTooltipHtml(
						dayData.EntPer100Ml?.toString(),
						CHART_TOOLTIP_ENTEROCOCCI_UNITS,
						formatDateAEST(dt, CHART_TOOLTIP_DATE_FORMAT, FORMAT_DATE_LOCALE),
						this.getRating(dayData.EntPer100Ml).split(' ')[0],
						this.getPointColour(dayData.EntPer100Ml)
					)]);				
				this.monthlyTrendsData[0].push(formatDateAEST(dt, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE));				
				this.monthlyTrendsData[1].push(dayData?.EntPer100Ml);
			}
            else
            {   
				this.monthlyTrendsData[0].push(formatDateAEST(day, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE));				
				this.monthlyTrendsData[1].push("");
            }			
		}	
		
		
		this.monthlyChartData = new google.visualization.DataView(chartData);
		this.monthlyChartData.setColumns([0, 1,
                       { 
							calc: (dataTable : any, rowIndex : any) => {							
								const enterococci = chartData.getValue(rowIndex, 1);
								return this.getPointColour(enterococci);
							},
							sourceColumn: 2,
							type: "string",
							role: "style" 
						}, 3
					]);
		

		let maxYValue = Math.max(...monthlyData.map((a : any) => a.EntPer100Ml));
		this.monthlyChartOptions = {			
			width: '100%', height: '100%',	
			explorer: {
				keepInBounds: true,
				actions : [],
				// actions: ['dragToZoom', 'rightClickToReset'],				
				// axis: 'horizontal',				
				//maxZoomOut: 0.9,
				//maxZoomIn: 0.9			 
			},
			// chartArea: {
			//     width: '95%',
			//     left: 40,
			//     right: 40
			// },
			tooltip : { isHtml : true, trigger : 'focus' },			
			// chartArea: {width: '100%', height: '80%'},
			hAxis : {
				format : TRENDS_TABLE_DATE_FORMAT,
				// minValue : minDate,
				// maxValue : maxDate,
				direction : -1, // most recent to oldest
				gridlines : {
					// multiple: 7,
					// count : 4,
					color: '#fff'
				},
				minorGridlines : {count : 0, color: '#fff'},
				ticks : [
					maxDate,
					sub(maxDate, {days : 7 }),
					sub(maxDate, {days : 14 }),
					sub(maxDate, {days : 21 }),
					sub(maxDate, {days : 28 })
				]
			},
			vAxis : {
                format : { format : "none" },
				minValue : 0,
				maxValue : maxYValue, 
				// set viewWindow.max to positive value >= in order to show only the positive y axis
				viewWindow : { min : 0, max : maxYValue >= 1 ? maxYValue : 1 },				
				minorGridlines : { count : 0 },
				gridlines : { count : 3 }
								
			},
			legend : "none"
		};		

		maxDate = new Date();
		minDate = sub(maxDate, {years : 1});		
		const yearlyData = sortedArray.filter((d) => {			
			return d.MeasurementDt.getTime() >= minDate.getTime() &&
				d.MeasurementDt.getTime() <= maxDate.getTime();
		});
		
		const yearlyChartData = new google.visualization.DataTable();
		yearlyChartData.addColumn('date', this.MEASUREMENT_DATE_LABEL);
		yearlyChartData.addColumn('number', this.ENTEROCOCCI_COLUMN);
		yearlyChartData.addColumn({'role' : 'style'});		
		yearlyChartData.addColumn({'type' : 'string', 'role' : 'tooltip', 'p': {'html': true}});	
		this.annualTrendsData = [[this.MEASUREMENT_DATE_LABEL], [this.ENTEROCOCCI_LABEL]];
		diffCalendarDays = differenceInCalendarDays(maxDate, minDate);
		for(let i = 0; i <= diffCalendarDays; ++i)
		{			
			const day = sub(maxDate, {days : i });			
			const dayData = yearlyData.find((a : any) => {
				const measurementDt = convertToAESTDateTime(a.MeasurementDt) ?? a.MeasurementDt;					
				const diff = differenceInCalendarDays(day, measurementDt);				
				return 0 === diff;
			});
			if(dayData)
			{
				const measurementDt = convertToAESTDateTime(dayData.MeasurementDt) ?? dayData.MeasurementDt;
				const dt = new Date(measurementDt.getFullYear(), measurementDt.getMonth(), measurementDt.getDate(),
					measurementDt.getHours(), measurementDt.getMinutes(), measurementDt.getSeconds(), measurementDt.getMilliseconds());

				yearlyChartData.addRow([dt, dayData.EntPer100Ml, 'color: red',
					formatTooltipHtml(
						dayData.EntPer100Ml?.toString(),
						CHART_TOOLTIP_ENTEROCOCCI_UNITS, 
						formatDateAEST(dt, CHART_TOOLTIP_DATE_FORMAT, FORMAT_DATE_LOCALE),
						this.getRating(dayData.EntPer100Ml),
						this.getPointColour(dayData.EntPer100Ml)
					)]);						
				
				
				this.annualTrendsData[0].push(formatDateAEST(dt, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE));
				this.annualTrendsData[1].push(dayData?.EntPer100Ml);
			}
            else
            {
				this.annualTrendsData[0].push(formatDateAEST(day, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE));				
				this.annualTrendsData[1].push("");            			
            }	
		}		
		
		
		this.annualChartData = new google.visualization.DataView(yearlyChartData);
		this.annualChartData.setColumns([0, 1,
                       { 
							calc: (dataTable : any, rowIndex : any) => {							
								const enterococci = yearlyChartData.getValue(rowIndex, 1);
								return this.getPointColour(enterococci);							
							},
							sourceColumn: 2,
							type: "string",
							role: "style" 
						},						
						3
					]);
		

		maxYValue = Math.max(...yearlyData.map((a : any) => a.EntPer100Ml));
		this.annualChartOptions = {
			interpolateNulls : false,
			tooltip : { isHtml : true, trigger : 'focus' },				
			width: '100%', height: '100%',
			explorer: {				
				//actions: [],
				keepInBounds: true,									
				axis: 'horizontal',				
				maxZoomOut: 1,
				maxZoomIn: 0.01	
			},
			// chartArea: {
			//     width: '100%',
			//     left: 40,
			// 	height : '90%'
			// },
			hAxis : {
				format : TRENDS_TABLE_DATE_FORMAT,
				// minValue : minDate,
				// maxValue : maxDate,
				direction : -1, // most recent to oldest
				gridlines : {
					color: '#fff'
				},
				minorGridlines : {count : 0, color: '#fff'},
				ticks : [
					sub(maxDate, {days: maxDate.getDay()}),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 1 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 2 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 3 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 4 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 5 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 6 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 7 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 8 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 9 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 10 }),
					sub(sub(maxDate, {days: maxDate.getDay()}), {months : 11 })
				],
				// slantedText: true,
          		// slantedTextAngle: 30,
				// viewWindowMode : 'pretty',
				// textStyle : {
				// 	textOverflow : '',					
				// 	whiteSpace: 'nowrap'
				// }
			},
			vAxis : {
                format : { format : "none" },
				minValue : 0,
				maxValue : maxYValue, 
				// set viewWindow.max to positive value >= in order to show only the positive y axis
				viewWindow : { min : 0, max : maxYValue >= 1 ? maxYValue : 1 },				
				minorGridlines : { count : 0 },
				gridlines : { count : 3 }
			},
			legend : "none"
		}
	}

	private getRating = (enterococci : number | null | undefined) => {
		if(null == enterococci)
		{
			return "";
		}

		if(enterococci < 41)
		{
			return "GOOD";
		}
		else if(enterococci >= 41 && enterococci <= 200)
		{
			return "FAIR";
		}
		else if(enterococci > 200 && enterococci <= 500)
		{
			return "POOR";
		}
		else
		{
			return "BAD";
		}		
	}

	private getPointColour = (enterococci : number | null | undefined) => {
		return DEEP_BLUE_HEX_COLOUR;
		// if(enterococci < 41)
		// {
		// 	return "#33BB6A"; // GOOD
		// }
		// else if(enterococci >= 41 && enterococci <= 200)
		// {
		// 	return "#BDE36E"; // FAIR
		// }
		// else if(enterococci > 200 && enterococci <= 500)
		// {
		// 	return "#F58249"; // POOR
		// }
		// else
		// {
		// 	return "#DF4461"; //  BAD
		// }		
	}
	

	get dataPoints() : any { 	
		
		const sortedArray = this.enterococciTrends?.sort(function compare(a, b) {
			const dateA = new Date(a.MeasurementDt);
			const dateB = new Date(b.MeasurementDt);
			return dateA.getTime() - dateB.getTime();
		});

		const xAxisLabels = uniq(sortedArray.map((a) => {
			return formatDateAEST(a.MeasurementDt, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE);			
		}));	

		const data = sortedArray.map((a : SiteEnterococciTrendModel, index : number) => {
			const dateMonth = formatDateAEST(a.MeasurementDt, TRENDS_TABLE_DATE_FORMAT, FORMAT_DATE_LOCALE);
			const x = xAxisLabels.indexOf(dateMonth);
			return { x :  dateMonth, y : a.EntPer100Ml, r : 10};
		});		
		
		return {
			labels: xAxisLabels,
			datasets : [
				{
					label : 'Scatter Dataset',
					data : data,
					borderColor: "transparent",                    
					backgroundColor: 'rgb(255, 99, 132)',
					fill: false,					
					tension: 0.1
				}
			]
		};
	}
	

	onExportDataClicked = (type : "Monthly" | "Annual") => {
		if(!this.siteId)
		{
			return;
		}		

        let dataResponse = "";
        let startDate = Date.now();

        //check type and create a date variable based on the current date minus 1 month or 1 year
        //divide by 1000 to get seconds not milliseconds
        if(type == "Monthly")
        {
            startDate = Math.trunc(new Date(Date.now()).setMonth(new Date(Date.now()).getMonth() - 1) / 1000);
        }
        else
        {
            startDate = Math.trunc(new Date(Date.now()).setFullYear(new Date(Date.now()).getFullYear() - 1) / 1000);
        }

		this.exportSub = this.siteDetailsService?.getSiteEnterococciTrend(this.siteId, "", "", "", true,startDate,Math.trunc(Date.now() / 1000))?.subscribe({
			next : (response : any) => {				
				if(response)
				{     
                    dataResponse = response;             
					
                    if(!this.isErrorResponse(response))
                    {                     				
                        downloadData(dataResponse, `${type}-${this.ENTEROCOCCI_COLUMN}-${new Date().getTime()?.toString()}`, "text/csv");                      
					}	
				}
			}, 
			error : (ex : Error) => {
                dataResponse = "";
			},
			complete : () => 
            {
				
			}
		});
	}

    private isErrorResponse = (response : any) => {
		try
		{
			const jsonResp = JSON.parse(response);
			if(jsonResp?.message)
			{
				alert(jsonResp?.message);												
				return true;
			}

		}
		catch(ex:any)
		{											
		}			
		return false;
	}

    private parseDataDDMMYYYY = (dateStr : string) => {
		let dt;
        if(/^\d{4}-(?:0[1-9]|1[0-2])-(?:[0-2][1-9]|[1-3]0|3[01])T(?:[0-1][0-9]|2[0-3])(?::[0-6]\d)(?::[0-6]\d)?(?:\.\d{3})?(?:[+-][0-2]\d:[0-5]\d|Z)?$/i.test(dateStr?.toString()))
		{
			dt = parseISO(dateStr?.toString()?.trim());
		}
		else if(/^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4} (?:[0-1][0-9]|2[0-3])(?::[0-6]\d)(?::[0-6]\d) [A|P]M [+-]\d{2}:\d{2}$/i.test(dateStr))
		{
			const parts = dateStr?.toString()?.trim()?.split(" ");
			const dateParts = dateStr[0].split("/");
			const month = Number(dateParts[0]) - 1;
			const day = Number(dateParts[1]);
			const year = Number(dateParts[2]);

			const timeParts = dateStr[1].split(":");
			let hours = Number(timeParts[0]);
			let minutes = Number(timeParts[1]);
			let seconds = Number(timeParts[2]);

			const timeZone = dateStr[2].substring(1).split(":");
			if(dateStr[2].startsWith("+"))
			{
				const sum = hours * 60 + minutes + Number(timeZone[1]) + Number(timeZone[0]) * 60;
				hours = Math.ceil(sum / 60);
				minutes = sum % 60;
			}
			else if(dateStr[2].startsWith("-"))
			{
				const sum = (hours * 60) + minutes - (Number(timeZone[1]) - Number(timeZone[0]) * 60);
				hours = Math.ceil(sum / 60);
				minutes = sum % 60
			}

			dt = new Date(year, month, day, hours, minutes, seconds);
		}
            
		return dt;
    }

	private formatDownloadData = (inputData : string, type : "Monthly" | "Annual") => {
		let data = inputData ?? "";
        if(!inputData)
        {
            return data;
        }

        try
        {
            const linesOfText = inputData?.toString()?.split(/\r?\n/);
            if(Array.isArray(linesOfText) && 1 < linesOfText.length)
            {			
                let parts = linesOfText[0].split(",");
                const dateIdx = parts.findIndex((a: string) => a?.toString()?.trim()?.toLocaleLowerCase() === MEASUREMENT_DATE_FIELD.toLocaleLowerCase());
                const entIdx = parts.findIndex((a: string) => a?.toString()?.trim()?.toLocaleLowerCase() === ENTEROCOCCI_FIELD.toLocaleLowerCase());
                if(-1 < dateIdx && -1 < entIdx)
                {
                    try
                    {
                        const adt : EnterococciExportDataStruct [] = [];
                        for(let i = 1; i < linesOfText.length; ++i)
                        {
                            if(linesOfText[i]?.toString()?.trim())
                            {
                                parts = linesOfText[i].split(",");
                                const enterococciValue = parts[entIdx]?.toString();
                                if(/^\d+$/i.test(enterococciValue))
                                {	
                                    const dt = this.parseDataDDMMYYYY(parts[dateIdx]?.toString());
									if(dt && "Invalid Date" !== dt?.toString())
									{
										adt.push({ 
											[MEASUREMENT_DATE_FIELD] : dt, 
											[ENTEROCOCCI_FIELD] : parseInt(enterococciValue) 
										});
									}
                                    
                                }										
                            }                            
                        }
                        const maxDate = new Date();
                        const minDate = type === "Annual" ? sub(maxDate, {years : 1}) : sub(maxDate, {days : 31});	
            
                        const exportData = adt.sort((a : EnterococciExportDataStruct, b : EnterococciExportDataStruct) => {
                            return b.MeasurementDt.getTime() - a.MeasurementDt.getTime();
                        }).filter((a) => {
                            return a[MEASUREMENT_DATE_FIELD].getTime() >= minDate.getTime();
                        })?.map((a) => {

                            return {
                                ...a,
                                [MEASUREMENT_DATE_FIELD] : formatDateAEST(a[MEASUREMENT_DATE_FIELD], TREND_EXPORT_DATA_DATE_FORMAT, FORMAT_DATE_LOCALE)							
                            };
                        });
                        
                        const newLinesOfText = [];					
                        newLinesOfText.push(`${this.MEASUREMENT_DATE_LABEL},${this.ENTEROCOCCI_LABEL}`);
                        for(let i = 0; i < exportData.length; ++i)
                        {
                            newLinesOfText.push(`${exportData[i][MEASUREMENT_DATE_FIELD]},${exportData[i][ENTEROCOCCI_FIELD]}`);				
                        }
            
                        data = newLinesOfText.join("\r\n");	
                    }
                    catch(ex)
                    {
                        data = inputData;
                    }
                }					
            }
        }
        catch(ex : any)
        {
            alert(ex?.message);
        }
		
		
		return data;
	}


	/* 
		Since the chart is nested a tab and the inactive tab will be hidden, the chart drawn in inactive tabe will
		not have the width and height of the parent. So defer drawing the chart till the tab is activated
	*/
	onTabActivated = (index : number) => {
		this.activeTabIndex = index;
	}
}
